function nowDateString () {
  return filter.formatDate(new Date())
}

export { nowDateString }



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-cache-box/utils.js